import * as children from './pages/*/routes.js'; //eslint-disable-line

export default {
  name: 'settings',
  path: 'settings',
  children,
};



// WEBPACK FOOTER //
// ./src/features/private/settings/routes.js